'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _katex = require('katex');

var _katex2 = _interopRequireDefault(_katex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TexInlineBlockModal = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(TexInlineBlockModal, _Component);

  function TexInlineBlockModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TexInlineBlockModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TexInlineBlockModal.__proto__ || (0, _getPrototypeOf2.default)(TexInlineBlockModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      content: _this.props.content
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TexInlineBlockModal, [{
    key: 'handleSaveClick',
    value: function handleSaveClick() {
      this.props.onSave(this.state.content);
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.onCancel();
    }
  }, {
    key: 'handleTextareaChange',
    value: function handleTextareaChange(event) {
      this.setState({ content: event.target.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var content = this.state.content;

      var styles = require('./TexInlineBlockModal.scss');

      var texHtml = void 0;
      try {
        texHtml = _katex2.default.renderToString(content, { displayMode: true, throwOnError: true });
      } catch (error) {
        texHtml = error.message;
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('div', { className: styles.mask, onClick: this.handleCancelClick.bind(this) }),
        _react2.default.createElement(
          'div',
          { className: styles.modal },
          _react2.default.createElement('textarea', { onChange: this.handleTextareaChange.bind(this), value: content }),
          _react2.default.createElement('div', { className: styles.preview, dangerouslySetInnerHTML: { __html: texHtml } }),
          _react2.default.createElement(
            'div',
            { className: styles.button, onClick: this.handleCancelClick.bind(this) },
            'Annuler'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.button, onClick: this.handleSaveClick.bind(this) },
            'Valider'
          )
        )
      );
    }
  }]);
  return TexInlineBlockModal;
}(_react.Component), _class.propTypes = {
  content: _react.PropTypes.String,
  onCancel: _react.PropTypes.func,
  onSave: _react.PropTypes.func
}, _temp2);
exports.default = TexInlineBlockModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/components/TexInlineBlockModal.js
// module id = 1188
// module chunks = 0